import React from "react";
import { ChevronRight } from "lucide-react";
import { useNavigate } from "react-router-dom";

interface CoachingCampsMobileProps {
  preachingImageUrl: string;
  passionsImageUrl: string;
}

const CoachingCampsMobile = ({ preachingImageUrl, passionsImageUrl }: CoachingCampsMobileProps) => {
  const navigate = useNavigate();
  
  const handleNavigate = (path: string) => {
    console.log("Coaching camps mobile navigating to:", path);
    navigate(path);
  };
  
  return (
    <div className="grid grid-cols-1 gap-4 mt-4 max-w-md mx-auto">
      {/* First section - Video Kurzüberblick */}
      <div className="space-y-2">
        <h4 className="text-base md:text-lg font-bold text-white text-center uppercase mb-3">
          Video Kurzüberblick Kompass-Camp
        </h4>
        <button 
          onClick={() => handleNavigate('/kurzueberblick')}
          className="group w-full relative rounded-lg overflow-hidden border border-white/20 transition-transform hover:scale-[1.02] h-[120px] md:h-[140px]"
        >
          <div className="aspect-video w-full h-full">
            <img
              src={passionsImageUrl}
              alt="Video Kurzüberblick Kompass-Camp"
              className="w-full h-full object-cover"
            />
            <div className="absolute inset-0 bg-black/30 group-hover:bg-black/40 transition-colors">
              <div className="absolute right-2 top-1/2 -translate-y-1/2 flex items-center animate-horizontal-bounce">
                <ChevronRight className="w-4 h-4 text-white" />
                <ChevronRight className="w-4 h-4 text-white -ml-2" />
              </div>
            </div>
          </div>
        </button>
      </div>
    </div>
  );
};

export default CoachingCampsMobile;